import { render, staticRenderFns } from "./DemandaJurisprudenciaButton.vue?vue&type=template&id=13df4e5a&scoped=true"
import script from "./DemandaJurisprudenciaButton.vue?vue&type=script&lang=js"
export * from "./DemandaJurisprudenciaButton.vue?vue&type=script&lang=js"
import style0 from "./DemandaJurisprudenciaButton.vue?vue&type=style&index=0&id=13df4e5a&prod&scoped=true&lang=css"
import style1 from "./DemandaJurisprudenciaButton.vue?vue&type=style&index=1&id=13df4e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df4e5a",
  null
  
)

export default component.exports